import { render, staticRenderFns } from "./vFormEditor.vue?vue&type=template&id=fd10fc90&scoped=true&"
import script from "./vFormEditor.vue?vue&type=script&lang=js&"
export * from "./vFormEditor.vue?vue&type=script&lang=js&"
import style1 from "./vFormEditor.vue?vue&type=style&index=1&id=fd10fc90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd10fc90",
  null
  
)

export default component.exports